import * as React from 'react';
import { CheckboxFilter } from '../../Filter/CheckboxFilter';
import { DropdownFilter } from '../../Filter/DropdownFilter';
import { OptionsCollection } from '../../Filter/OptionsCollection';
import { RangeSliderFilter } from '../../Filter/RangeSliderFilter';
import { Trans } from '../../Trans';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';
import { AnalogOutputCollector } from '../AnalogOutputCollector';
import { FilterInfo } from '../FilterInfo';

interface FilterViewProps extends FilterSectionViewProps {
}

export class TensionControllerFilterView extends AbstractFilterSectionView<FilterViewProps> {
    public render() {
        return <div className="pf-filter-container">
            <div className="pf-filter-section">
                <div className="row">
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Schnittstelle</Trans></div>
                        <CheckboxFilter filter={this.getFilter('@parent.Feldbus')}
                                        options={this.collectAvailable('@parent.Feldbus')}
                                        onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Schutzart</Trans></div>
                        <CheckboxFilter filter={this.getFilter('Schutzart')}
                                        options={this.collectAvailable('Schutzart')}
                                        onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Anzahl Kanäle</Trans></div>
                        <RangeSliderFilter filter={this.getFilter('@parent.Anzahl_Kanaele')}
                                           options={this.collectAvailable<number>('@parent.Anzahl_Kanaele')}
                                           onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Anzahl Kraftaufnehmer</Trans></div>
                        <DropdownFilter filter={this.getFilter('@parent.Anzahl_Kraftaufnehmer')}
                                        options={this.collectAvailable('@parent.Anzahl_Kraftaufnehmer')}
                                        onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Analogausgänge</Trans></div>
                        <CheckboxFilter filter={this.getFilter('analogOutput')}
                                        options={this.collectAvailableAnalogOutputs()}
                                        onChange={this.handleChange}/>
                    </div>
                </div>
            </div>
            <FilterInfo {...this.props}/>
        </div>;
    }

    private collectAvailableAnalogOutputs(): OptionsCollection<string> {
        return AnalogOutputCollector.collectAvailableAnalogOutputs(this.props, true);
    }
}
